import { filterPartiesByPartyTypeCode } from "./filterPartiesByPartyTypeCode";

export const getAllAnnuitantsFromParties = (parties) => {
  const order = { IN: 0, JA: 1, CA: 2 };
  return filterPartiesByPartyTypeCode(parties, ["IN", "JA", "CA"]).sort(
    (a, b) => order[a.person.partyTypeCode] - order[b.person.partyTypeCode]
  );
};
